import { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import servicesStrings from '../../strings';
import {
  AlternativeNameItem as ItemWrapper,
  AlternativeNameDisplay,
  AlternativeNameText,
  ActionButtons,
  EditButton,
  DeleteButton,
  AlternativeInput,
} from './AlternativeNamesModal.style';

const AlternativeNameItem = ({ alternativeName, onUpdate, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const editInputRef = useRef(null);

  // Auto-focus input when entering edit mode
  useEffect(() => {
    if (isEditing && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [isEditing]);

  const handleStartEdit = () => {
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  const handleBlur = e => {
    const newName = e.target.value;
    onUpdate(alternativeName, newName);
    setIsEditing(false);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.target.blur();
    } else if (e.key === 'Escape') {
      handleCancelEdit();
      e.target.blur();
    }
  };

  const handleDelete = () => {
    onDelete(alternativeName);
  };

  return (
    <ItemWrapper>
      <AlternativeNameDisplay>
        {isEditing ? (
          <AlternativeInput
            ref={editInputRef}
            type="text"
            defaultValue={alternativeName}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            style={{ flex: 1 }}
          />
        ) : (
          <>
            <AlternativeNameText>{alternativeName}</AlternativeNameText>
            <ActionButtons>
              <EditButton onClick={handleStartEdit}>
                {servicesStrings.alternativeNames.editButton}
              </EditButton>
              <DeleteButton onClick={handleDelete}>
                {servicesStrings.alternativeNames.deleteButton}
              </DeleteButton>
            </ActionButtons>
          </>
        )}
      </AlternativeNameDisplay>
    </ItemWrapper>
  );
};

AlternativeNameItem.propTypes = {
  alternativeName: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AlternativeNameItem;
